import { useCallback, useMemo } from 'react';

import { useLocale } from '../useSitecoreContext';

/**
 * Format a number according to the current locale. Affects things like decimal
 * and thousand separators.
 */
export function useNumberFormatter(type: 'decimal' | 'integer' = 'decimal') {
	const { locale } = useLocale();

	const formatter = useMemo(
		() =>
			new Intl.NumberFormat(locale, {
				style: 'decimal',
				maximumFractionDigits: type === 'decimal' ? 1 : 0,
			}),
		[locale, type],
	);

	return useCallback(
		(num: number | undefined): string =>
			num === undefined ? '' : formatter.format(num),
		[formatter],
	);
}
